module.exports = __webpack_public_path__ + "static/media/lane-error.b430285f.png";